
<div class="card text-decoration-none bg-emphasis bg-opacity-25">
    <div class="card-body align-items-center text m-5px">
        <div class="d-flex fw-bold small mb-1 text-truncate text-uppercase">
            {{widget.name}}
          </div>
        <div class="size-comparison-widget" *ngIf="c && c.timeSeriesDetailList">

            <highcharts-chart
                [Highcharts]="Highcharts"
                [constructorType]="stockConstructor"
                [options]="chartOptions"
                [callbackFunction]="chartCallback"
                style="width: 100%; display: block">
            </highcharts-chart>

        </div>
    </div>
    <!-- card-arrow -->
    <div class="card-arrow">
        <div class="card-arrow-top-left"></div>
        <div class="card-arrow-top-right"></div>
        <div class="card-arrow-bottom-left"></div>
        <div class="card-arrow-bottom-right"></div>
    </div>
</div>